<template>
  <div
    v-if="loadingStatus"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div
      class="spinner mx-auto"
      style="border: 3px solid rgb(141 183 227 / 30%);border-top-color: #80b1fc;"
    ></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>

  <div v-else id="page" class="min-h-screen w-full flex overflow-hiddden ">
    <design-panel
      class="min-h-screen"
      :survey="survey"
      :step="step"
      :key="step.id"
    >
    </design-panel>

    <div
      class="relative md:ml-72 w-full h-full flex flex-col min-h-screen justify-between"
    >
      <div class="fixed top-0 w-full" style="left:0">
        <Navbar
          id="header"
          class="md:ml-72 bg-gray-100 border-b border-solid border-gray-200 opacity-100 py-2"
        >
          <template v-slot:left>
            <div id="name" class="flex flex-row">
              <div v-tooltip="'Back to surveys'">
                <router-link :to="{ name: 'survey-list' }">
                  <svg-icon
                    icon="heroicons/outline/chevron-double-left"
                    class="h-8 w-8"
                  ></svg-icon>
                </router-link>
              </div>

              <click-to-edit
              v-model="name"
              pClass="text-xl font-bold block px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
              inputClass="text-xl block px-5 cursor-pointer rounded align-middle w-full"
              
              :pStyle="{ 'width': 'fit-content', 'min-height': '1.8rem' }"
              :inputStyle="{ 'min-height': '1.8rem'  }"
            ></click-to-edit>

            </div>
          </template>

          <template v-slot:right>
            <div id="buttons" class="flex flex-row mr-5">
              <router-link
                :to="{ path: '/preview/' + survey.id + '/start' }"
                class="mr-2 hover:text-white hover:no-underline block bg-gray-800 hover:bg-gray-600 text-white active:bg-indigo-600 font-bold uppercase text-xs px-4 py-3 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                type="button"
                style="transition: all .15s ease"
              >
                Preview
              </router-link>

              <button
                @click="saveSurvey()"
                class="block bg-purple-600 hover:bg-purple-500 text-white active:bg-indigo-600 font-bold uppercase text-xs rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                type="button"
                style="transition: all .15s ease"
              >
                <span v-if="saving" class="spinner mx-11"></span>
                <span v-else class="mx-4 my-3">Save Survey</span>
              </button>
            </div>
          </template>
        </Navbar>
      </div>
      <header-notification></header-notification>

      <!--Delete Modal -->
      <BaseModal
        :showModal="showDeleteModal"
        v-on:close="showDeleteModal = false"
        v-on:confirm="
          deleteStep();
          showDeleteModal = false;
        "
      >
        <template v-slot:body>
          <p class="text-sm text-gray-500">
            <strong
              >Warning: you will lose any existing responses you have received
              for this question.
            </strong>
            <br />

            Are you sure you want to delete this question and lose existing
            responses? This action cannot be undone.
          </p>
        </template>
      </BaseModal>

      <!--Image Select Modal -->
      <keep-alive>
        <image-select-modal
          v-if="showImageModal"
          @close="closeModal()"
          :accentColor="survey.accentColor"
          :option="imageModalObject"
        ></image-select-modal>
      </keep-alive>

      <!--Spacer to allow room for fixed header-->
      <div style="margin-top: 53px"></div>

      <div
        id="survey-panel"
        class="w-full px-4 md:px-10 flex flex-col justify-center pt-8 pb-20 flex-grow"
        :style="{ 'background-color': bgColor }"
      >
        <div
          v-if="step.buttonY == 'top'"
          class="flex-none flex flex-row-reverse mt-5"
        >
          <SurveyButton :survey="survey" :step="step" class="mt-5 mb-5" />
        </div>

        <div
          v-if="step.type == 'image'"
          class="display-image-step"
          :key="step.id"
        >
          <div class="mx-auto font-bold text-center">
            <click-to-edit
              v-model="title"
              pClass="text-xl block mx-auto px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
              inputClass="text-xl block mx-auto px-5 cursor-pointer rounded text-center"
              
              :pStyle="{ color: fontColor, 'font-family': survey.fontFamily, 'width': 'fit-content', 'min-height': '1.8rem' }"
              :inputStyle="{ 'font-family': survey.fontFamily,  'min-height': '1.8rem'  }"
            ></click-to-edit>

          </div>
          <div class="mx-auto text-center mt-1">

            <click-to-edit
              v-model="subtitle"
              pClass="block mx-auto px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
              inputClass="block mx-auto px-5 cursor-pointer rounded text-center"
              
              :pStyle="{ color: fontColor, 'font-family': survey.fontFamily, 'width': 'fit-content',  'min-height': '1.5rem'  }"
              :inputStyle="{ 'font-family': survey.fontFamily,  'min-height': '1.5rem'  }"
            ></click-to-edit>
          </div>

          <div class="flex flex-wrap justify-center mt-2">
            <!-- Options Panels Start -->
            <draggable
              v-model="options"
              handle=".my-handle"
              draggable=".draggable"
              :key="step.id"
            >
              <transition-group
                name="list"
                tag="div"
                class="flex flex-wrap justify-center"
                :key="step.id"
                id="option_list"
                :style="{ 'max-width': containerWidth }"
              >
                <survey-option
                  :key="option.id"
                  v-for="option in options"
                  :option="option"
                  :survey="survey"
                  :step="step"
                  v-on:remove-option="removeOption"
                  v-on:clone-option="cloneOption"
                  v-on:open-modal="openModal"
                  class="draggable"
                ></survey-option>
              </transition-group>
            </draggable>

            <!-- End Options -->

            <div class="flex items-center justify-center">
              <div @click="addOption" class="block">
                <svg-icon
                  icon="heroicons/outline/plus"
                  class="mt-2 w-10 h-10 p-0 text-gray-100 cursor-pointer bg-purple-400 hover:bg-purple-700 rounded-full"
                  v-tooltip="'Add a new answer choice'"
                />
              </div>
            </div>
          </div>

          <SurveyButton :survey="survey" :step="step" class="mt-5 mb-5" @click="stepIndex++" />

        </div>

        <WelcomeStep
          :key="step.id"
          v-if="step.type == 'welcome'"
          :survey="survey"
          :step="step"
          @remove-option="removeOption"
          @open-modal="openModal"
          @next-step="stepIndex++"
          
        />

        <CloseStep
          :key="step.id"
          v-if="step.type == 'end'"
          :survey="survey"
          :step="step"
        />
      </div>

      <builder-footer
        :survey="survey"
        :currentStep="stepIndex"
        :step="step"
        :saving="saving"
        @add-step="addStep"
        @clone-step="cloneStep"
        @select-step="setStep"
        @confirm-delete="confirmDelete"
      ></builder-footer>
    </div>
  </div>
</template>

<script>
//import { FontFamily } from "@/mixins/FontFamily.js";
import { ConsoleLogApiErrors } from "@/mixins/Mixins.js";

import Navbar from "@/components/Header.vue";
import SurveyOption from "@/components/Builder/SurveyOption.vue";
import DesignPanel from "@/components/Builder/DesignPanel.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import BuilderFooter from "@/components/Builder/Footer.vue";
//import ClickToRte from "@/components/ClickToRte.vue";
import HeaderNotification from "@/components/HeaderNotification.vue";
//import ImageSelectModal from "@/components/Builder/ImageSelectModal.vue";

import WelcomeStep from "@/components/Builder/WelcomeStep.vue";

import CloseStep from "@/components/Builder/CloseStep.vue";

import { mapState } from "vuex";
import Survey from "@/models/Survey";
import Step from "@/models/Step";
import Option from "@/models/Option";
import router from "@/router/route.js";
import SurveyButton from "@/components/Survey/SurveyButton.vue";

//Draggable/Sortable component
//https://sortablejs.github.io/Vue.Draggable/#/simple
import Draggable from "vuedraggable";

export default {
  name: "survey-builder",
  mixins: [ConsoleLogApiErrors],
  components: {
    Navbar,
    WelcomeStep,
    CloseStep,
    Draggable,
    SurveyOption,
    DesignPanel,
    ClickToEdit,
    SurveyButton,
    //ClickToRte,
    HeaderNotification,
    BuilderFooter,
    ImageSelectModal: () =>
      import(
        /* webpackPrefetch: true */ "@/components/Builder/ImageSelectModal.vue"
      ),
  },
  props: ["surveyid"],
  data() {
    return {
      stepIndex: 0,
      showDeleteModal: false,
      showImageModal: false,
      loadingStatus: true,
      saving: false,
      imageModalObject: null,
    };
  },
  computed: {
    ...mapState("notification", ["notifications"]),
    font: {
      get() {
        return this.survey.font;
      },
      set(value) {
        if (value !== this.survey.font) {
          Survey.update({ where: this.survey.id, data: { font: value } });
        }
      },
    },
    user() {
      return this.$store.state.auth.user;
    },
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .with("buttons")
        .with("steps", (query) => {
          query.orderBy("order", "asc").with("options", (query) => {
            query.orderBy("order", "asc");
          });
        })
        .first();

      //if (surveyLoaded !== null) return surveyLoaded;
      //else return this.surveyDefault;
    },
    steps: {
      get() {
        return this.survey.steps;
      },
      set(steps) {
        var reorderedList = Step.reIndexList(steps);
        Step.update({
          data: reorderedList,
        });
      },
    },
    step() {
      return this.stepIndex > -1 ? this.survey.steps[this.stepIndex] : null;
    },
    containerWidth() {
      return this.step.containerWidth();
    },
    options: {
      get() {
        return this.step.options;
      },
      set(options) {
        var reorderedList = Option.reIndexList(options);

        Option.update({
          data: reorderedList,
        });
      },
    },
    name: {
      get() {
        return this.survey.name;
      },
      set(value) {
        if (value !== this.survey.name) {
          Survey.update({
            where: this.survey.id,
            data: {
              name: value,
            },
          });
        }
      },
    },
    title: {
      get() {
        return this.step.title;
      },
      set(value) {
        if (value !== this.step.title) {
          Step.update({
            where: this.step.id,
            data: {
              title: value,
            },
          });
        }
      },
    },
    subtitle: {
      get() {
        return this.step.subtitle;
      },
      set(value) {
        if (value !== this.step.subtitle) {
          Step.update({
            where: this.step.id,
            data: {
              subtitle: value,
            },
          });
        }
      },
    },
    bgColor() {
      return this.survey.bgColor;
    },
    fontColor() {
      return this.survey.fontColor;
    },
  },
  methods: {
    async init() {
      this.loadingStatus = true;
      var id = this.$route.params.surveyid || null;

      console.log("init: " + id);

      if (id === null) {
        router.push({ name: "survey-list" });
      }

      //if survey is not already loaded in state, request it from the server
      if (this.survey === null || typeof this.steps !== "undefined") {
        await Survey.api().get("/api/survey/" + id, {
          dataKey: "data",
        });
      }
      this.loadingStatus = false;
    },
    setStep(index) {
      this.stepIndex = index;
    },
    async addStep(type = null) {
      var stepData = Step.seed(this.survey.id);
      if (type) {

        stepData[0].type = type;
        stepData[0].options = [];
        
        if (type === "end") {
          stepData[0].title = "Sweet! You are all done.";
          stepData[0].subtitle = '';
          
        }

        if (type === "welcome") {
          stepData[0].title = "Welcome to this App.";
          stepData[0].subtitle =
            "We have a few quick questions for you to help us customize your experience.";
          stepData[0].image = "undraw/undraw_through_the_park_lxnl";
          stepData[0].order = -1;
          
        }
      }

      //console.log ("Type: " + type + "StepData: " + JSON. stringify(stepData));

      await Step.insert({
        data: stepData,
      });

      if (type == 'welcome')
        this.stepIndex = 0;
      else
        //go to last step
        this.stepIndex = this.steps.length - 1;

      this.$store.dispatch("notification/add", {
        message: "New step successfully created.",
      });
    },
    async cloneStep() {
      let stepClone = Step.clone(this.step);

      var step = await Step.insertNew({
        data: stepClone,
      });

      this.stepIndex = this.stepIndex + 1;
      this.$store.dispatch("notification/add", {
        message: "New step created.",
      });
    },
    confirmDelete() {
      this.showDeleteModal = true;
    },
    async deleteStep() {
      var self = this;
      //Delete step from database
      await Step.api()
        .delete("/api/step/delete/" + this.step.id)
        .then(() => {
          //On success, delete step from entities state
          Step.delete(this.step.id);
          self.$store.dispatch("notification/add", {
            message: "Step has been deleted.",
          });
          self.stepIndex = 0;
        })
        .catch(function(error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
          self.$store.dispatch("notification/add", {
            message: "An error occured deleting step",
          });
        });

      /*
try{
      if (result.response.status == 200) {
        //On success, delete step from entities state
        Step.delete(this.step.id);
        this.$store.dispatch("notification/add", {
          message: "Step has been deleted.",
        });
        this.stepIndex = 0;
      } else {
        this.$store.dispatch("notification/add", {
          message: "An error occured deleting step",
        });
      }
} catch (err) {

  this.$store.dispatch("notification/add", {
          message: "An error occured deleting step",
        });

}
*/
      /*
      if (result.response.status == 200) {
        this.$store.dispatch("notification/add", {
          message: result.response.data.success.message,
        });
      } else {
        this.$store.dispatch("notification/add", {
          message: "An error occured deleting step",
        });
      }
*/
    },
    async addOption() {
      var optionData = Option.seed(this.step.id);

      Option.insert({
        data: optionData,
      });

      //Option.api().post("/api/option/store", optionData);
    },
    async removeOption(option) {
      var result = await Option.api().delete("/api/option/delete/" + option.id);

      if (result.response.status == 200) {
        //Delete step from entities state
        option.$delete();
      } else {
        //Delete failed
        this.$store.dispatch("notification/add", {
          message: "An error occured deleting option",
        });
      }
    },
    cloneOption(option) {
      let optionClone = Option.clone(option);

      Option.insert({
        data: optionClone,
      });
    },
    async saveSurvey() {
      this.saving = true;

      //Normalize survey into separate arrays for each model
      //var normalizedSurvey = Survey.getNormalizedData(this.survey.id);

      try {
        var post = await Survey.api().post("/api/survey/save", this.survey);
      } catch (err) {
        //Log error
        this.$store.dispatch("notification/add", {
          message: "An error occured saving survey",
        });
      }

      this.saving = false;

      if (post.response.status == 200) {
        this.$store.dispatch("notification/add", {
          message: post.response.data.success.message,
        });
      } else {
        this.$store.dispatch("notification/add", {
          message: post.response.data.error.message,
        });
      }
    },
    closeModal: function() {
      this.showImageModal = false;
      window.removeEventListener("keydown", this.onEscape);
    },
    openModal: function(object) {
      this.imageModalObject = object;
      this.showImageModal = true;
      window.addEventListener("keydown", this.onEscape);
    },
    onEscape: function(e) {
      if (this.showImageModal && e.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  created() {
    this.init();
  },
  destroyed() {
    window.removeEventListener("keydown", this.onEscape);
  },
};
</script>

<style>
#page {
  overflow-x: hidden;
}

/* Add option animation */
.list-enter-active {
  transition: all 1s;
}

.list-enter /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

/* Step change Animation */
.slide-leave-active {
  transition: 0.01s;
}
.slide-enter-active {
  transition: 0.8s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.panel-sm,
.panel-md,
.panel-lg {
  width: 250px;
}
@media (min-width: 640px) {
  .panel-sm {
    width: 250px;
  }
  .panel-md {
    width: 300px;
  }
  .panel-lg {
    width: 330px;
  }
}
@media (min-width: 1024px) {
  .panel-sm {
    width: 250px;
  }
  .panel-md {
    width: 330px;
  }
  .panel-lg {
    width: 400px;
  }
}
.sortable-chosen {
  opacity: 1;
}

.sortable-chosen div {
  opacity: 1;
}

.sortable-ghost {
  border: 2px dashed rgb(203, 160, 204);
  border-radius: 10px;
  background: rgb(250, 233, 249);

}
.sortable-ghost div {
  opacity: 0;

}

.sortable-drag {


}
</style>
